import Transform from '@ember-data/serializer/transform';
import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';
import { ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';

// eslint-disable-next-line ember/no-classic-classes
export default Transform.extend({
  deserialize(JSON, options) {
    const modelClass = options.modelClass;
    if (isNone(modelClass)) {
      assert("You must pass the model class into the transform's options hash");
      return undefined;
    }
    return isNone(JSON) ? undefined : modelClass.deserialize(JSON);
  },
  serialize(model) {
    return isNone(model) ? undefined : ProtoBaseModel.serialize(model);
  }
});